import { Component } from "react"

/* Constants */
import { utils, sound, env } from "../constants"

/* UUID */
import { v4 as uuidv4 } from "uuid"

/* Components */
import { Picture, Chip } from "@cuba-go/poker-ui"

import Rates from "./Rates"

/* Components */
// import Chip from "../components/Chip"

/* Widget Bet */
class Bet extends Component {


    constructor() {
        super()

        this.state = {
            history: [],
        }
    }

    add = () => {

        /* Fields */
        const { history } = this.state
        const { setAnte, ante, balance, toggleBalanceError, toggleMaxBetError, active, max, chips } = this.props

        /* Get Chips */
        const chipsList = utils.getChips(chips)

        /* Assign History Values */
        let list = history
        const index = chipsList.findIndex(c => c.key === active)

        if (index > -1) {

            const current = chipsList[index]

            const initialBalance = balance + (ante ? ante : 0)

            /* Balance Error */
            if (initialBalance === null || initialBalance === undefined || parseInt(initialBalance) === 0 || parseInt(initialBalance) < (parseInt(ante) + parseInt(current.value)) * 4) {
                toggleBalanceError()
                return
            }

            /* Max Bet Error */
            if (parseInt(ante + current.value) > parseInt(max)) {
                toggleMaxBetError()
                return
            }

            /* Push History */
            const uid = uuidv4()
            list.push({ ...current, uid })
            this.setState({ history: list })

            /* Set Ante */
            setAnte(ante + current.value)
        } else {
            sound.play("blocked", 0.6)
        }
    }


    /* Clear action */
    clear = () => {
        const { setAnte } = this.props
        this.setState({ history: [] })
        setAnte(0)
        sound.play()
    }


    /* Cancel action */
    cancel = () => {

        /* Fields */
        const { history } = this.state
        const { setAnte, ante } = this.props

        /* Assign History Value */
        let list = history

        /* Check Ante */
        if (ante > 0 && history.length > 0) {
            const last = list.pop()
            this.setState({ history: list })
            setAnte(ante - last.value)
        }
    }


    /* Double action */
    double = () => {

        /* Fields */
        const { history } = this.state
        const { setAnte, ante, balance, toggleBalanceError, toggleMaxBetError, max, chips } = this.props

        /* Assign History Values */
        let list = history

        /* Check Ante */
        if (ante > 0) {

            /* Check Balance */
            if (balance === null || balance === undefined || parseInt(balance) === 0 || parseInt(balance) < parseInt(ante * 2) * 4) {
                toggleBalanceError()
                return
            }

            /* Check Max Bet */
            if (parseInt(ante * 2) > parseInt(max)) {
                toggleMaxBetError()
                return
            }

            /* Set History */
            const uid = uuidv4()
            list.push({ key: 7, value: ante, uid })
            this.setState({ history: list })

            /* Set Ante */
            setAnte(ante * 2)

        } else {
            sound.play("blocked", 0.6)
        }
    }


    /* Refresh action */
    refresh = () => {

        /* Fields */
        const { history } = this.state
        const { setAnte, ante, last, balance, toggleBalanceError, toggleMaxBetError, max, chips } = this.props

        /* Assign History Values */
        let list = history

        /* Check Last */
        if (last > 0 && ante === 0) {

            /* Check Balance */
            if (balance === null || balance === undefined || parseInt(balance) === 0 || parseInt(balance) < parseInt(last) * 4) {
                toggleBalanceError()
                return
            }

            /* Check Max Bet */
            if (parseInt(last) > parseInt(max)) {
                toggleMaxBetError()
                return
            }

            /* Create History */
            const uid = uuidv4()
            list.push({ key: 8, value: last, uid })
            this.setState({ history: list })

            /* Set Ante */
            setAnte(last)
        } else {
            sound.play("blocked", 0.6)
        }

    }


    /* SET DEFAULT CHIP */
    setActiveChip = item => {

        const { active, setActiveChip } = this.props

        if (item.key !== active) {
            setActiveChip(item.key)
            sound.play("selectchip")
        }
        else {
            this.add()
        }

    }


    /* Draw Chips */
    _chips = () => {

        /* Fields */
        const { active } = this.props
        const { chips } = this.props

        const list = utils.getChips(chips)

        return (
            <div className="chips">
                {list.map((item, index) =>
                    <div onClick={() => this.setActiveChip(item)} key={`${index}`} className={item.key === active ? `chip active-chip` : `chip`}>
                        <Chip value={item.value} chips={chips} size={82} />
                    </div>
                )}
            </div>

        )
    }


    render = () => {

        /* Fields */
        const { history } = this.state
        const { ante, last, currency, boxStyle, anteAnimatedStyle, active, chips } = this.props

        /* Status */
        const disabled = !ante
        const cancelDisabled = history.length === 0

        return (
            <div className="bet">

                <div className="bet-panel">

                    <div className="bet-buttons">

                        {/* Clear Button */}
                        <div className={`bet-button ${disabled && "disabled"}`} onClick={() => this.clear()}>
                            <Picture src={`${env.mediapoint}/images/bet/delete.png`} alt="Delete" />
                            <span>Очистить</span>
                        </div>

                        {/* Cancel Button */}
                        <div className={`bet-button ${cancelDisabled && "disabled"}`} onClick={() => this.cancel()}>
                            <Picture src={`${env.mediapoint}/images/bet/cancel.png`} alt="Cancel" />
                            <span>Отменить</span>
                        </div>

                    </div>

                    {/* Chips */}
                    {this._chips()}

                    <div className="bet-buttons">

                        {/* Double Up Button */}
                        <div className={`bet-button ${disabled && "disabled"}`} onClick={() => this.double()}>
                            <div className="bet-title">2x</div>
                            <span>Удвоить</span>
                        </div>

                        {/* Cancel Button */}
                        <div className={`bet-button ${(!last || ante) && "disabled"}`} onClick={() => this.refresh()}>
                            <Picture src={`${env.mediapoint}/images/bet/refresh.png`} alt="Refresh" />
                            <span>Повторить</span>
                        </div>

                    </div>

                </div>

                <div className="pc-rates-outer">
                    <Rates
                        currency={currency}
                        history={history}
                        fromBet={true}
                        add={() => this.add()}
                        ante={ante}
                        active={active}
                        bet={() => sound.play("blocked", 0.6)}
                        boxStyle={boxStyle}
                        anteAnimatedStyle={anteAnimatedStyle}
                        chips={chips}
                    />
                </div>

            </div>
        )
    }

}

export default Bet